import { Box, Link, Modal } from "@mui/material";

const ImageViewer = ({ src, handleClose }) => {
  // Todo:
  // Fix the performance
  // fix the hasNavigated thingy
  // fix dark reader

  return (
    <Modal
      open={true}
      onClose={handleClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
      slotProps={{
        backdrop: {
          sx: {
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.80)",
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          outline: "none",
          height: "max-content",
          width: "90vh",
          marginLeft: "5vw",
          marginRight: "5vw",
          gap: "10px",
        }}
      >
        <Box
          component="img"
          src={src}
          sx={{
            height: "auto",
            width: "100%",
            maxHeight: "90vh",
            objectFit: "contain",
          }}
        />
        <Link
          target="_blank"
          rel="noreferrer"
          href={src}
          sx={{
            textDecoration: "none",
            fontWeight: "bold",
            color: "text.secondary",

            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          Open Original
        </Link>
      </Box>
    </Modal>
  );
};

export default ImageViewer;
